import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import App from './App';
import Header from './components/Header';
// import 'semantic-ui-css/semantic.min.css';
// import './index.css';
import './styles/reset.css';
import './styles/app.css';
import './styles/icon.css';
import './styles/index.css';
import { UserProvider } from './context/User';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StatusProvider } from './context/Status';
import { isAdmin } from './helpers';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatusProvider>
      <UserProvider>
        <BrowserRouter>
          {isAdmin() && <Header />}
          <Container className={'main-content'}>
            <App />
          </Container>
          <ToastContainer />
        </BrowserRouter>
      </UserProvider>
    </StatusProvider>
  </React.StrictMode>
);
